import React from 'react';
import {
  CEHeadlineContainer,
  CEValue,
  CEValueList,
  CEValueRow,
} from './ConsumptionEmissionLayerPlp.styles';
import { Headline, Text, TextLink } from '@oneaudi/unified-web-components';
import { ConsumptionEmissionDataType, FootnoteReference } from '@oneaudi/vtp-shared';

interface ConsumptionAndEmissionDisplayProps {
  dataToRender: (ConsumptionEmissionDataType | null)[];
}

export const ConsumptionAndEmissionDisplay: React.FC<ConsumptionAndEmissionDisplayProps> = ({
  dataToRender,
}) => {
  return (
    <div>
      {dataToRender.map((caeData) =>
        caeData ? (
          <React.Fragment key={`Consumption-Emission-${caeData.headline}`}>
            <CEHeadlineContainer>
              <Headline
                tag="h4"
                variant={{
                  order: '4',
                  type: 'headline',
                  weight: 'normal',
                }}
              >
                {caeData.headline}
              </Headline>
              {caeData.linkUrl && caeData.linkLabel && (
                <TextLink
                  variant="standalone"
                  icon="external-link"
                  iconPosition="trailing"
                  href={caeData.linkUrl}
                  size="md"
                  target="_blank"
                >
                  {caeData.linkLabel}
                </TextLink>
              )}
            </CEHeadlineContainer>
            <CEValueList>
              {caeData.fuelData[0].consumptionData.map((consumption) => {
                return (
                  <CEValueRow key={consumption.key}>
                    <Text
                      tag="p"
                      variant={{
                        order: '1',
                        style: 'bold',
                      }}
                    >
                      {consumption.label}
                      <FootnoteReference
                        refId={`fn_${caeData.testCycleType?.toLowerCase()}_stockcar`}
                      />
                    </Text>
                    <CEValue
                      tag="p"
                      variant={{
                        order: '1',
                        style: 'normal',
                      }}
                    >
                      {`${consumption.value} ${consumption.unit}`}
                    </CEValue>
                  </CEValueRow>
                );
              })}
              <CEValueRow>
                <Text
                  tag="p"
                  variant={{
                    order: '1',
                    style: 'bold',
                  }}
                >
                  {caeData.fuelData[0].emissionData.label}
                  <FootnoteReference
                    refId={`fn_${caeData.testCycleType?.toLowerCase()}_stockcar`}
                  />
                </Text>
                <CEValue
                  tag="p"
                  variant={{
                    order: '1',
                    style: 'normal',
                  }}
                >
                  {`${caeData.fuelData[0].emissionData.value} ${caeData.fuelData[0].emissionData.unit}`}
                </CEValue>
              </CEValueRow>
            </CEValueList>
            {caeData.fuelData[0].range && (
              <CEValueList>
                <Headline
                  tag="h4"
                  variant={{
                    order: '4',
                    type: 'headline',
                    weight: 'normal',
                  }}
                >
                  {caeData.fuelData[0].range?.headline}
                </Headline>
                {caeData.fuelData[0].range?.data.map((rangeData) => (
                  <CEValueRow key={rangeData.key}>
                    <Text
                      tag="p"
                      variant={{
                        order: '1',
                        style: 'bold',
                      }}
                    >
                      {rangeData.label}
                      <FootnoteReference
                        refId={`fn_${caeData.testCycleType?.toLowerCase()}_stockcar`}
                      />
                    </Text>
                    <CEValue
                      tag="p"
                      variant={{
                        order: '1',
                        style: 'normal',
                      }}
                    >
                      {`${rangeData.value} ${rangeData.unit}`}
                    </CEValue>
                  </CEValueRow>
                ))}
              </CEValueList>
            )}
          </React.Fragment>
        ) : null
      )}
    </div>
  );
};
